import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {conditional} from '../../../util/conditional';
import store from '../../../store';
import {classes} from '../../../../../common/tpl/directives';
import {filterAndJoin} from '../../../util/filterAndJoin';
import {getValueOfFeature, hasFeatureValue, pimText, pimTextDebug} from '../../../util/values';
import {
    selectCRI,
	selectDimensionHeight, selectDimensionWidth, selectDimensionDepth,
    selectWeight,
	selectWindsurfacearea
} from '../../../selectors';

@customElement('avanza-page-summary')
export class AvanzaPageSummary extends connect(store)(LitElement) {

	static styles = css`
	.summary {
		display: flex;
		padding-top: 5vw;
		width: 100%;
	}

	.summaryContainer {
		width: 50%;
	}

	.description {
		width: 50%;
	}

	.imageContainer {
		text-align: center;
		width: 50%;
	}

	.imageContainer img {
		margin: auto;
		width: 100%;
		height: auto;
	}

	@media print {
		.summary {
			display: flex;
			padding-top: 5vw;
			width: 100vw;
		}

		.imageContainer {
			text-align: center;
			width: 50vw;
		}

		.imageContainer img {
			margin: auto;
			width: 100%;
			height: auto;
		}
	}
	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.featuremodel = state.featureModel;
		this.productData = state.productData;
		this.status = state.status;
		this.lang = state.status.lang;
		this.decisions = state.decisions.data;
		this.conditionalVariantValues = state.productData.conditionalVariantValues;
	}

	t(featureId, context, value, prefix, suffix) {
		return this.debug ?
			pimTextDebug(this.lang, featureId, context, this.state.decisions.data, this.state.productData.translations, value, prefix, suffix) :
			pimText(this.lang, featureId, context, this.state.decisions.data, this.state.productData.translations, value, prefix, suffix);
	}
	c(id) {
		return conditional(this.decisions, this.conditionalVariantValues, id);
	}
	render() {
		const s = this.state;
		return html`
				<div class="summary">
					<div class="summaryContainer">
						<div class="imageContainer">
							${when( this.c('REDTAB.RETURN_LU_Image') && this.c('REDTAB.RETURN_LU_Image') !=='', () => html`
								<img class="img" alt="product image" src="${this.c('REDTAB.RETURN_LU_Image')}" />
							`)}
						</div>
					</div>

					<div class="description">
						<features-full-list line-choice="no-line" class-name="specsheet"></features-full-list>
					</div>
				</div>
		`;
	}
}
